<template>
    <div id="converters">
        <router-link
        :to="{name: 'new_converter', params: {}}"
        class="ui basic positive button"
        >
            <i class="plus icon"></i>
            新增翻譯本
        </router-link>
        <table class="ui celled table">
            <thead>
                <tr>
                    <th>名稱</th>
                    <th>操作</th>
                </tr>
            </thead>
            <tbody>
                <Converter v-if="is_initialized" :key="converter.id" v-for="converter in converters" :converter="converter" />
            </tbody>
        </table>
    </div>
</template>

<script>
import Converter from "../.components/index/converter.vue"
export default {
    data: function () {
        return {
            is_initialized: false,
            converters: [],
        }
    },
    computed: {
        fetch_converters_url: function() {
            return this.$store.state.admin.converters_module.admin_converters_routes.index;
        }
    },
    created: function() {
        this.init();
    },
    mounted: function() {
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "converters") {
                this.init();
            }
        },
    },
    methods: {
        init: async function() {
            var that = this;
            await new Promise(resolve => {
                that.is_initialized = false;
                resolve();
            })
            await that.fetch_converters();
            await new Promise(resolve => {
                that.is_initialized = true;
                resolve();
            });
        },
        fetch_converters: function() {
            var that = this;
            var url = new RestUrl(that.fetch_converters_url).parse(
                {},
                ""
            );
            return axios.get(url)
                .then(function (response) {
                    that.converters = response.data.converters;
                    return response;
                })
                .catch(function (error) {
                    // that.$noty.error('取得Converters失敗');
                    that.$noty.error(
                        that.$t('ui.notifications.error.fetch__name',{
                            name: 'Converter',
                            reason: ': ' + error
                        })
                    );
                    return Promise.reject(error);
                });
        },
    },
    components: {
        Converter,
    }
}
</script>
